module.exports = __webpack_public_path__ + "static/media/onlyfans.d00858f2.svg";